export const PrevIcon = () => (
  <svg
    width="23"
    height="22"
    viewBox="0 0 23 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.0383 5.5L8.53833 11L14.0383 16.5"
      stroke="#484848"
      stroke-width="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ViewIcon = () => (
  <svg
    width="24"
    height="16"
    viewBox="0 0 24 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0001 11.2716C13.8074 11.2716 15.2726 9.80647 15.2726 7.9991C15.2726 6.19173 13.8074 4.72656 12.0001 4.72656C10.1927 4.72656 8.72754 6.19173 8.72754 7.9991C8.72754 9.80647 10.1927 11.2716 12.0001 11.2716Z"
      fill="#809DEA"
    />
    <path
      d="M12 0.363281C5.4544 0.363281 0 7.45421 0 7.99981C0 8.54488 5.4544 15.6363 12 15.6363C18.5453 15.6363 24 8.54541 24 7.99981C24 7.45395 18.5456 0.363281 12 0.363281ZM12 13.4542C8.98667 13.4542 6.5456 11.0126 6.5456 7.99981C6.5456 4.98621 8.98667 2.54541 12 2.54541C15.0131 2.54541 17.4544 4.98621 17.4544 7.99981C17.4544 11.0126 15.0131 13.4542 12 13.4542Z"
      fill="#809DEA"
    />
  </svg>
);

export const EditIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.56427 15.0999C1.41691 14.9524 1.14325 15.0156 1.10115 15.2263L0.00649472 19.6505C-0.0356074 19.8612 0.132801 20.0508 0.343311 19.9876L4.78508 18.9131C4.99559 18.871 5.0798 18.5971 4.91139 18.4496L1.56427 15.0999Z"
      fill="#809DEA"
    />
    <path
      d="M14.2166 2.12393C14.1113 2.01859 13.9219 2.01859 13.8166 2.12393L2.44906 13.5004C2.3438 13.6058 2.3438 13.7954 2.44906 13.9007L6.11194 17.5665C6.21719 17.6718 6.40665 17.6718 6.51191 17.5665L17.8795 6.18997C17.9847 6.08463 17.9847 5.89502 17.8795 5.78968L14.2166 2.12393Z"
      fill="#809DEA"
    />
    <path
      d="M19.1638 0.837436C18.0481 -0.279145 16.2166 -0.279145 15.1009 0.837436C15.0588 0.879572 15.0588 0.921707 15.1009 0.963842L19.0375 4.90348C19.0796 4.94561 19.1217 4.94561 19.1638 4.90348C20.2795 3.7869 20.2795 1.95402 19.1638 0.837436Z"
      fill="#809DEA"
    />
  </svg>
);

export const NextIcon = () => (
  <svg
    width="23"
    height="22"
    viewBox="0 0 23 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.53833 16.5L14.0383 11L8.53833 5.5"
      stroke="#484848"
      stroke-width="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SearchIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
      stroke="#484848"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.0001 14.0001L11.1001 11.1001"
      stroke="#484848"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PaperClipIcon = ({
  stroke = "#484848",
  width = 25,
  height = 25,
}: {
  stroke?: string;
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.09 12.5008L12.9558 19.635C12.0818 20.509 10.8964 21 9.6604 21C8.42438 21 7.23899 20.509 6.365 19.635C5.491 18.761 5 17.5756 5 16.3396C5 15.1036 5.491 13.9182 6.365 13.0442L13.4992 5.91C14.0819 5.32734 14.8721 5 15.6961 5C16.5201 5 17.3104 5.32734 17.8931 5.91C18.4757 6.49266 18.8031 7.28292 18.8031 8.10693C18.8031 8.93094 18.4757 9.7212 17.8931 10.3039L10.7511 17.4381C10.4598 17.7294 10.0646 17.8931 9.65263 17.8931C9.24063 17.8931 8.8455 17.7294 8.55417 17.4381C8.26284 17.1467 8.09917 16.7516 8.09917 16.3396C8.09917 15.9276 8.26284 15.5325 8.55417 15.2411L15.145 8.6581"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AddIcon = (props: any) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 6V0H8V6H14V8H8V14H6V8H0V6H6Z"
      fill={props.color || "#ffffff"}
    />
  </svg>
);

export const TrashIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 4H3.33333H14"
      stroke="#FF6060"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33301 3.99992V2.66659C5.33301 2.31296 5.47348 1.97382 5.72353 1.72378C5.97358 1.47373 6.31272 1.33325 6.66634 1.33325H9.33301C9.68663 1.33325 10.0258 1.47373 10.2758 1.72378C10.5259 1.97382 10.6663 2.31296 10.6663 2.66659V3.99992M12.6663 3.99992V13.3333C12.6663 13.6869 12.5259 14.026 12.2758 14.2761C12.0258 14.5261 11.6866 14.6666 11.333 14.6666H4.66634C4.31272 14.6666 3.97358 14.5261 3.72353 14.2761C3.47348 14.026 3.33301 13.6869 3.33301 13.3333V3.99992H12.6663Z"
      stroke="#FF6060"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66699 7.33325V11.3332"
      stroke="#FF6060"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33301 7.33325V11.3332"
      stroke="#FF6060"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DeleteIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse
      cx="15.6701"
      cy="15.5154"
      rx="15.6701"
      ry="15.5154"
      fill="#FFECEA"
    />
    <path
      d="M9.7959 11.6367H11.1017H21.5485"
      stroke="#DD4433"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.0603 11.6367V10.3437C13.0603 10.0008 13.1979 9.67195 13.4428 9.42948C13.6877 9.187 14.0198 9.05078 14.3662 9.05078H16.9779C17.3242 9.05078 17.6563 9.187 17.9012 9.42948C18.1461 9.67195 18.2837 10.0008 18.2837 10.3437V11.6367M20.2425 11.6367V20.6873C20.2425 21.0302 20.1049 21.3591 19.86 21.6016C19.6151 21.844 19.283 21.9803 18.9366 21.9803H12.4074C12.0611 21.9803 11.7289 21.844 11.484 21.6016C11.2391 21.3591 11.1016 21.0302 11.1016 20.6873V11.6367H20.2425Z"
      stroke="#DD4433"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.3662 14.8691V18.748"
      stroke="#DD4433"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.978 14.8691V18.748"
      stroke="#DD4433"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UserIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="8.5"
      cy="8.5"
      r="8"
      fill="#DD4433"
    />
    <path
      d="M11.8333 12.25V11.4167C11.8333 10.9746 11.6577 10.5507 11.3451 10.2382C11.0326 9.9256 10.6087 9.75 10.1666 9.75H6.83329C6.39127 9.75 5.96734 9.9256 5.65478 10.2382C5.34222 10.5507 5.16663 10.9746 5.16663 11.4167V12.25"
      stroke="white"
      stroke-width="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.50004 8.08333C9.42052 8.08333 10.1667 7.33714 10.1667 6.41667C10.1667 5.49619 9.42052 4.75 8.50004 4.75C7.57957 4.75 6.83337 5.49619 6.83337 6.41667C6.83337 7.33714 7.57957 8.08333 8.50004 8.08333Z"
      stroke="white"
      stroke-width="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DownloadIcon = (props: any) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.66675 14.1667L10.0001 17.5001L13.3334 14.1667"
      stroke={props.color || "#685F5F"}
      stroke-width="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 10V17.5"
      stroke={props.color || "#685F5F"}
      stroke-width="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.4001 15.0749C18.1246 14.5655 18.6679 13.8384 18.9511 12.9992C19.2344 12.1601 19.2429 11.2525 18.9754 10.4081C18.7079 9.5638 18.1783 8.82669 17.4635 8.30375C16.7486 7.7808 15.8858 7.49925 15.0001 7.49994H13.9501C13.6994 6.52317 13.2305 5.61598 12.5785 4.84668C11.9265 4.07737 11.1085 3.46599 10.1861 3.05857C9.26363 2.65115 8.26077 2.4583 7.253 2.49454C6.24524 2.53078 5.25883 2.79517 4.36803 3.2678C3.47723 3.74043 2.70525 4.40898 2.11022 5.22314C1.51519 6.03729 1.11261 6.97582 0.932784 7.96807C0.752958 8.96032 0.800575 9.98044 1.07205 10.9516C1.34352 11.9228 1.83178 12.8198 2.50007 13.5749"
      stroke={props.color || "#685F5F"}
      stroke-width="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ReloadIcon = (props: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.038 19.5c-2.094 0-3.867-.727-5.32-2.18-1.453-1.452-2.18-3.225-2.18-5.319 0-2.093.727-3.866 2.18-5.32C8.17 5.227 9.944 4.5 12.038 4.5c1.17 0 2.276.26 3.32.78a7.106 7.106 0 0 1 2.603 2.2V5.25c0-.213.072-.39.216-.534a.726.726 0 0 1 .534-.216c.213 0 .391.072.535.216a.726.726 0 0 1 .215.534v4.461c0 .257-.086.471-.26.644a.875.875 0 0 1-.644.26h-4.461a.725.725 0 0 1-.535-.215.726.726 0 0 1-.215-.535c0-.213.072-.39.215-.534a.726.726 0 0 1 .535-.216h3.2a5.884 5.884 0 0 0-2.193-2.281A5.888 5.888 0 0 0 12.038 6c-1.667 0-3.083.583-4.25 1.75-1.167 1.167-1.75 2.583-1.75 4.25 0 1.667.583 3.083 1.75 4.25 1.167 1.167 2.583 1.75 4.25 1.75a5.856 5.856 0 0 0 3.192-.915 5.906 5.906 0 0 0 2.195-2.443.784.784 0 0 1 .418-.381.797.797 0 0 1 .562-.013.654.654 0 0 1 .428.4.661.661 0 0 1-.02.577 7.449 7.449 0 0 1-2.742 3.109c-1.21.777-2.554 1.166-4.033 1.166z"
      fill={props.color || "#685F5F"}
    />
  </svg>
);

export const CalenderIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8333 3.33325H4.16667C3.24619 3.33325 2.5 4.07944 2.5 4.99992V16.6666C2.5 17.5871 3.24619 18.3333 4.16667 18.3333H15.8333C16.7538 18.3333 17.5 17.5871 17.5 16.6666V4.99992C17.5 4.07944 16.7538 3.33325 15.8333 3.33325Z"
      stroke="#484848"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3333 1.66675V5.00008"
      stroke="#484848"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66675 1.66675V5.00008"
      stroke="#484848"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 8.33325H17.5"
      stroke="#484848"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DocIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.74 8.67V8.70273L19.7504 8.73375C19.7743 8.80458 19.7909 8.87763 19.8 8.95177V8.95179V8.95209V8.95239V8.95269V8.95299V8.95329V8.95359V8.95388V8.95418V8.95447V8.95476V8.95505V8.95534V8.95563V8.95592V8.9562V8.95649V8.95677V8.95705V8.95733V8.95761V8.95789V8.95817V8.95844V8.95872V8.95899V8.95926V8.95953V8.9598V8.96007V8.96034V8.96061V8.96087V8.96113V8.9614V8.96166V8.96192V8.96218V8.96244V8.96269V8.96295V8.9632V8.96346V8.96371V8.96396V8.96421V8.96446V8.9647V8.96495V8.9652V8.96544V8.96568V8.96592V8.96617V8.9664V8.96664V8.96688V8.96712V8.96735V8.96758V8.96782V8.96805V8.96828V8.96851V8.96874V8.96896V8.96919V8.96941V8.96964V8.96986V8.97008V8.9703V8.97052V8.97074V8.97096V8.97117V8.97139V8.9716V8.97182V8.97203V8.97224V8.97245V8.97266V8.97287V8.97307V8.97328V8.97348V8.97369V8.97389V8.97409V8.97429V8.97449V8.97469V8.97488V8.97508V8.97528V8.97547V8.97566V8.97586V8.97605V8.97624V8.97643V8.97661V8.9768V8.97699V8.97717V8.97736V8.97754V8.97772V8.9779V8.97808V8.97826V8.97844V8.97862V8.97879V8.97897V8.97914V8.97932V8.97949V8.97966V8.97983V8.98V8.98017V8.98034V8.9805V8.98067V8.98083V8.981V8.98116V8.98132V8.98148V8.98164V8.9818V8.98196V8.98212V8.98227V8.98243V8.98258V8.98274V8.98289V8.98304V8.98319V8.98334V8.98349V8.98364V8.98379V8.98393V8.98408V8.98422V8.98437V8.98451V8.98465V8.9848V8.98494V8.98507V8.98521V8.98535V8.98549V8.98562V8.98576V8.98589V8.98603V8.98616V8.98629V8.98642V8.98655V8.98668V8.98681V8.98694V8.98706V8.98719V8.98732V8.98744V8.98756V8.98769V8.98781V8.98793V8.98805V8.98817V8.98829V8.98841V8.98852V8.98864V8.98876V8.98887V8.98898V8.9891V8.98921V8.98932V8.98943V8.98954V8.98965V8.98976V8.98987V8.98997V8.99008V8.99019V8.99029V8.9904V8.9905V8.9906V8.9907V8.9908V8.9909V8.991V8.9911V8.9912V8.9913V8.99139V8.99149V8.99159V8.99168V8.99177V8.99187V8.99196V8.99205V8.99214V8.99223V8.99232V8.99241V8.9925V8.99259V8.99267V8.99276V8.99285V8.99293V8.99301V8.9931V8.99318V8.99326V8.99334V8.99343V8.99351V8.99359V8.99366V8.99374V8.99382V8.9939V8.99397V8.99405V8.99412V8.9942V8.99427V8.99435V8.99442V8.99449V8.99456V8.99463V8.9947V8.99477V8.99484V8.99491V8.99498V8.99504V8.99511V8.99517V8.99524V8.9953V8.99537V8.99543V8.99549V8.99556V8.99562V8.99568V8.99574V8.9958V8.99586V8.99592V8.99598V8.99603V8.99609V8.99615V8.9962V8.99626V8.99632V8.99637V8.99642V8.99648V8.99653V8.99658V8.99663V8.99669V8.99674V8.99679V8.99684V8.99688V8.99693V8.99698V8.99703V8.99708V8.99712V8.99717V8.99722V8.99726V8.9973V8.99735V8.99739V8.99744V8.99748V8.99752V8.99756V8.9976V8.99764V8.99769V8.99773V8.99776V8.9978V8.99784V8.99788V8.99792V8.99795V8.99799V8.99803V8.99806V8.9981V8.99813V8.99817V8.9982V8.99824V8.99827V8.9983V8.99834V8.99837V8.9984V8.99843V8.99846V8.99849V8.99852V8.99855V8.99858V8.99861V8.99864V8.99866V8.99869V8.99872V8.99875V8.99877V8.9988V8.99883V8.99885V8.99888V8.9989V8.99892V8.99895V8.99897V8.99899V8.99902V8.99904V8.99906V8.99908V8.99911V8.99913V8.99915V8.99917V8.99919V8.99921V8.99923V8.99925V8.99927V8.99928V8.9993V8.99932V8.99934V8.99935V8.99937V8.99939V8.9994V8.99942V8.99944V8.99945V8.99947V8.99948V8.9995V8.99951V8.99953V8.99954V8.99955V8.99957V8.99958V8.99959V8.9996V8.99962V8.99963V8.99964V8.99965V8.99966V8.99967V8.99968V8.9997V8.99971V8.99972V8.99973V8.99973V8.99974V8.99975V8.99976V8.99977V8.99978V8.99979V8.9998V8.9998V8.99981V8.99982V8.99983V8.99985V8.99986V8.99987V8.99988V8.99989V8.9999V8.99991V8.99992V8.99993V8.99994V8.99995V8.99996V8.99996V8.99997V8.99998V8.99999V9V19C19.8 19.7426 19.505 20.4548 18.9799 20.9799C18.4548 21.505 17.7426 21.8 17 21.8H7C6.25739 21.8 5.5452 21.505 5.0201 20.9799C4.495 20.4548 4.2 19.7426 4.2 19V5C4.2 4.25739 4.495 3.5452 5.0201 3.0201C5.5452 2.495 6.25739 2.2 7 2.2H13.0369C13.1226 2.21206 13.2053 2.24038 13.2805 2.28349L13.3401 2.31767L13.4081 2.30801C13.4112 2.30757 13.4144 2.30725 13.4175 2.30705C13.4878 2.34355 13.5529 2.38951 13.6108 2.44369L19.6063 8.43916C19.659 8.49557 19.704 8.5587 19.74 8.62688V8.67ZM14.1414 5.26858L13.8 4.92716V5.41V7C13.8 7.31826 13.9264 7.62348 14.1515 7.84853C14.3765 8.07357 14.6817 8.2 15 8.2H16.59H17.0728L16.7314 7.85858L14.1414 5.26858ZM12.2 4V3.8H12H7C6.68174 3.8 6.37652 3.92643 6.15147 4.15147C5.92643 4.37652 5.8 4.68174 5.8 5V19C5.8 19.3183 5.92643 19.6235 6.15147 19.8485C6.37652 20.0736 6.68174 20.2 7 20.2H17C17.3183 20.2 17.6235 20.0736 17.8485 19.8485C18.0736 19.6235 18.2 19.3183 18.2 19V10V9.8H18H15C14.2574 9.8 13.5452 9.505 13.0201 8.9799C12.495 8.4548 12.2 7.74261 12.2 7V4ZM10 9.8H9C8.78783 9.8 8.58434 9.71571 8.43431 9.56569C8.28429 9.41566 8.2 9.21217 8.2 9C8.2 8.78783 8.28429 8.58434 8.43431 8.43431C8.58434 8.28429 8.78783 8.2 9 8.2H10C10.2122 8.2 10.4157 8.28429 10.5657 8.43431C10.7157 8.58434 10.8 8.78783 10.8 9C10.8 9.21217 10.7157 9.41566 10.5657 9.56569C10.4157 9.71571 10.2122 9.8 10 9.8ZM8.43431 12.4343C8.58434 12.2843 8.78783 12.2 9 12.2H15C15.2122 12.2 15.4157 12.2843 15.5657 12.4343C15.7157 12.5843 15.8 12.7878 15.8 13C15.8 13.2122 15.7157 13.4157 15.5657 13.5657C15.4157 13.7157 15.2122 13.8 15 13.8H9C8.78783 13.8 8.58434 13.7157 8.43431 13.5657C8.28429 13.4157 8.2 13.2122 8.2 13C8.2 12.7878 8.28429 12.5843 8.43431 12.4343ZM8.43431 16.4343C8.58434 16.2843 8.78783 16.2 9 16.2H15C15.2122 16.2 15.4157 16.2843 15.5657 16.4343C15.7157 16.5843 15.8 16.7878 15.8 17C15.8 17.2122 15.7157 17.4157 15.5657 17.5657C15.4157 17.7157 15.2122 17.8 15 17.8H9C8.78783 17.8 8.58434 17.7157 8.43431 17.5657C8.28429 17.4157 8.2 17.2122 8.2 17C8.2 16.7878 8.28429 16.5843 8.43431 16.4343Z"
      fill="#DD4433"
      stroke="white"
      stroke-width="0.4"
    />
  </svg>
);

export const ChangeClientPasswordIcon = (props: any) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5 6.5L18 3M20 1L18 3L20 1ZM10.39 10.61C10.9064 11.1195 11.3168 11.726 11.5978 12.3948C11.8787 13.0635 12.0246 13.7813 12.0271 14.5066C12.0295 15.232 11.8884 15.9507 11.6119 16.6213C11.3355 17.2919 10.9291 17.9012 10.4162 18.4141C9.90326 18.9271 9.29395 19.3334 8.62333 19.6099C7.95271 19.8864 7.23403 20.0275 6.50866 20.025C5.7833 20.0226 5.06557 19.8767 4.39682 19.5958C3.72807 19.3148 3.1215 18.9043 2.61203 18.388C1.61016 17.3507 1.05579 15.9614 1.06832 14.5193C1.08085 13.0772 1.65928 11.6977 2.67903 10.678C3.69877 9.65825 5.07824 9.07982 6.52032 9.06729C7.96241 9.05476 9.35172 9.60913 10.389 10.611L10.39 10.61ZM10.39 10.61L14.5 6.5L10.39 10.61ZM14.5 6.5L17.5 9.5L21 6L18 3L14.5 6.5Z"
      stroke={props.color}
      stroke-width="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SideBarHome = (props: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z"
      stroke={props.color}
      stroke-width="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 22V12H15V22"
      stroke={props.color}
      stroke-width="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SideBarServices = (props: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 7H4C2.89543 7 2 7.89543 2 9V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V9C22 7.89543 21.1046 7 20 7Z"
      stroke={props.color}
      stroke-width="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 21V5C16 4.46957 15.7893 3.96086 15.4142 3.58579C15.0391 3.21071 14.5304 3 14 3H10C9.46957 3 8.96086 3.21071 8.58579 3.58579C8.21071 3.96086 8 4.46957 8 5V21"
      stroke={props.color}
      stroke-width="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SideBarAssignClients = (props: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 3H3V10H10V3Z"
      stroke={props.color}
      stroke-width="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 3H14V10H21V3Z"
      stroke={props.color}
      stroke-width="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 14H14V21H21V14Z"
      stroke={props.color}
      stroke-width="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 14H3V21H10V14Z"
      stroke={props.color}
      stroke-width="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SideBarAllUsersAndClients = (props: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"
      stroke={props.color}
      stroke-width="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z"
      stroke={props.color}
      stroke-width="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13"
      stroke={props.color}
      stroke-width="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88"
      stroke={props.color}
      stroke-width="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SideBarPayment = (props: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.262 11.9c.365 0 .69-.142.974-.427.284-.284.426-.616.426-.995 0-.364-.142-.685-.426-.962-.284-.277-.609-.416-.974-.416-.364 0-.689.139-.973.416-.284.277-.426.598-.426.962 0 .38.142.711.426.995.284.285.609.427.973.427zM3.938 15.903v1.16V3.938v11.965zm0 2.472c-.335 0-.638-.131-.907-.394a1.244 1.244 0 0 1-.405-.919V3.938c0-.335.135-.638.405-.907.27-.27.572-.405.908-.405h13.124c.35 0 .657.135.92.405.262.27.393.572.393.908v2.93h-1.313v-2.93L3.938 3.938v13.125h13.126v-2.909h1.312v2.91c0 .35-.131.656-.394.918a1.259 1.259 0 0 1-.919.394l-13.125-.001zm7.832-3.784c-.496 0-.89-.146-1.181-.438-.292-.292-.438-.678-.438-1.16V8.029c0-.496.146-.886.438-1.17.291-.285.685-.427 1.18-.427h5.907c.496 0 .89.142 1.181.427.292.284.438.674.438 1.17v4.966c0 .481-.146.867-.438 1.16-.291.29-.685.437-1.181.437l-5.906-.001z"
      fill="#6E7491"
    />
  </svg>
);
export const SideBarBuy = (props: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.279 19.293c-.438 0-.81-.157-1.116-.47a1.556 1.556 0 0 1-.46-1.127c0-.423.154-.787.46-1.094a1.52 1.52 0 0 1 1.116-.46c.423 0 .79.154 1.105.46a1.5 1.5 0 0 1 .47 1.116c0 .438-.153.81-.46 1.116a1.52 1.52 0 0 1-1.115.459zm8.75 0c-.438 0-.81-.157-1.116-.47a1.556 1.556 0 0 1-.46-1.127c0-.423.154-.787.46-1.094a1.52 1.52 0 0 1 1.116-.46c.423 0 .79.154 1.105.46a1.5 1.5 0 0 1 .47 1.116c0 .438-.153.81-.46 1.116a1.519 1.519 0 0 1-1.115.459zM5.249 4.855l2.298 4.79h6.3l2.625-4.79H5.25zm.81 9.888c-.642 0-1.101-.215-1.378-.645-.277-.43-.27-.908.022-1.433l1.378-2.56-3.303-6.978H1.75a.657.657 0 0 1-.492-.218.71.71 0 0 1-.208-.504c0-.204.07-.375.208-.514a.698.698 0 0 1 .514-.207h1.465c.146 0 .28.036.405.109.125.075.222.19.273.328l.613 1.29H17.26c.54 0 .875.16 1.006.482.132.32.088.685-.13 1.094l-2.866 5.162c-.16.248-.376.467-.646.657s-.565.284-.886.284H7.154L5.973 13.3h9.996c.19 0 .354.072.493.218a.711.711 0 0 1 .207.503.699.699 0 0 1-.207.514.695.695 0 0 1-.514.208H6.06z"
      fill="#6E7491"
    />
  </svg>
);

export const SideBarAbout = (props: any) => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.564 14.941a.7.7 0 0 0 .514-.208.698.698 0 0 0 .208-.514v-3.894a.657.657 0 0 0-.22-.492.71.71 0 0 0-.502-.208.698.698 0 0 0-.514.208.698.698 0 0 0-.208.514v3.894c0 .19.073.354.219.492a.71.71 0 0 0 .503.208zm-.066-6.847a.807.807 0 0 0 .58-.219.75.75 0 0 0 .23-.568.824.824 0 0 0-.494-.773.767.767 0 0 0-.316-.058.767.767 0 0 0-.58.24.823.823 0 0 0-.23.59.75.75 0 0 0 .5.737c.099.037.204.055.31.051zm0 11.288c-1.254 0-2.424-.226-3.51-.679a8.633 8.633 0 0 1-2.822-1.87 8.632 8.632 0 0 1-1.87-2.822c-.453-1.086-.68-2.256-.68-3.51 0-1.24.227-2.403.679-3.49a8.633 8.633 0 0 1 1.87-2.822 8.922 8.922 0 0 1 6.333-2.57c1.24 0 2.403.23 3.49.69a8.777 8.777 0 0 1 2.82 1.88A8.807 8.807 0 0 1 18.692 7c.459 1.08.689 2.246.689 3.5 0 1.255-.23 2.425-.69 3.511a8.775 8.775 0 0 1-1.88 2.822 8.632 8.632 0 0 1-2.822 1.87 8.99 8.99 0 0 1-3.49.679zm0-1.488c2.027 0 3.767-.722 5.218-2.165 1.45-1.444 2.176-3.187 2.176-5.229 0-2.027-.725-3.766-2.176-5.217-1.451-1.45-3.19-2.176-5.218-2.176-2.027 0-3.766.725-5.217 2.176-1.45 1.451-2.176 3.19-2.176 5.217 0 2.042.725 3.785 2.176 5.229 1.45 1.443 3.19 2.165 5.217 2.165z"
      fill="#6E7491"
    />
  </svg>
);

export const ViewPassword = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#dd4433"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    className="feather feather-eye"
  >
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
    <circle
      cx="12"
      cy="12"
      r="3"
    ></circle>
  </svg>
);

export const HidePassword = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#dd4433"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    className="feather feather-eye-off"
  >
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
    <line
      x1="1"
      y1="1"
      x2="23"
      y2="23"
    ></line>
  </svg>
);

// export const InvoiceIcon = (props: any) => (
//     <svg viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
//     <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
//         <g id="icon-55-document-text" fill="#000000">
//             <path d="M19.5,3 L9.00276013,3 C7.89666625,3 7,3.89833832 7,5.00732994 L7,27.9926701 C7,29.1012878 7.89092539,30 8.99742191,30 L24.0025781,30 C25.1057238,30 26,29.1017876 26,28.0092049 L26,10.5 L26,10 L20,3 L19.5,3 L19.5,3 L19.5,3 Z M19,4 L8.9955775,4 C8.44573523,4 8,4.45526288 8,4.99545703 L8,28.004543 C8,28.5543187 8.45470893,29 8.9999602,29 L24.0000398,29 C24.5523026,29 25,28.5550537 25,28.0066023 L25,11 L20.9979131,11 C19.8944962,11 19,10.1134452 19,8.99408095 L19,4 L19,4 Z M20,4.5 L20,8.99121523 C20,9.54835167 20.4506511,10 20.9967388,10 L24.6999512,10 L20,4.5 L20,4.5 Z M10,10 L10,11 L17,11 L17,10 L10,10 L10,10 Z M10,7 L10,8 L17,8 L17,7 L10,7 L10,7 Z M10,13 L10,14 L23,14 L23,13 L10,13 L10,13 Z M10,16 L10,17 L23,17 L23,16 L10,16 L10,16 Z M10,19 L10,20 L23,20 L23,19 L10,19 L10,19 Z M10,22 L10,23 L23,23 L23,22 L10,22 L10,22 Z M10,25 L10,26 L23,26 L23,25 L10,25 L10,25 Z" id="document-text" sketch:type="MSShapeGroup"></path>
//         </g>
//     </g>
// </svg>
// )

export const InvoiceIcon = () => (
  <svg
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 294.842 294.842"
  >
    <g>
      <path
        d="M288.842,0H6C2.687,0,0,2.687,0,6v282.842c0,3.313,2.687,6,6,6h240.421c3.313,0,6-2.687,6-6s-2.687-6-6-6H12V12h270.842
   v276.842c0,3.313,2.687,6,6,6s6-2.687,6-6V6C294.842,2.687,292.155,0,288.842,0z"
      />
      <path
        d="M65.815,62.421c-12.683,0-23,10.317-23,23s10.317,23,23,23s23-10.317,23-23S78.498,62.421,65.815,62.421z M65.815,96.421
   c-6.065,0-11-4.935-11-11s4.935-11,11-11s11,4.935,11,11S71.881,96.421,65.815,96.421z"
      />
      <path d="M246.815,79.421h-140c-3.313,0-6,2.687-6,6s2.687,6,6,6h140c3.313,0,6-2.687,6-6S250.129,79.421,246.815,79.421z" />
      <path
        d="M65.815,124.421c-3.313,0-6,2.687-6,6s2.687,6,6,6c6.065,0,11,4.935,11,11s-4.935,11-11,11s-11-4.935-11-11
   c0-3.313-2.687-6-6-6s-6,2.687-6,6c0,12.683,10.317,23,23,23s23-10.317,23-23S78.498,124.421,65.815,124.421z"
      />
      <path d="M246.815,141.421h-140c-3.313,0-6,2.687-6,6s2.687,6,6,6h140c3.313,0,6-2.687,6-6S250.129,141.421,246.815,141.421z" />
      <path
        d="M65.815,186.421c-12.683,0-23,10.317-23,23s10.317,23,23,23s23-10.317,23-23S78.498,186.421,65.815,186.421z
    M65.815,220.421c-6.065,0-11-4.935-11-11s4.935-11,11-11s11,4.935,11,11S71.881,220.421,65.815,220.421z"
      />
      <path d="M246.815,203.421h-140c-3.313,0-6,2.687-6,6s2.687,6,6,6h140c3.313,0,6-2.687,6-6S250.129,203.421,246.815,203.421z" />
    </g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
  </svg>
);

export const UploadIcon = () => (
  <svg
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 294.156 294.156"
  >
    <g>
      <path
        d="M227.002,108.256c-2.755-41.751-37.6-74.878-80.036-74.878c-42.447,0-77.298,33.141-80.038,74.907
		C28.978,113.059,0,145.39,0,184.184c0,42.234,34.36,76.595,76.595,76.595h116.483c3.313,0,6-2.687,6-6s-2.687-6-6-6H76.595
		C40.977,248.778,12,219.801,12,184.184c0-34.275,26.833-62.568,61.087-64.411c3.184-0.171,5.678-2.803,5.678-5.991
		c0-0.119-0.003-0.236-0.01-0.355c0.09-37.536,30.654-68.049,68.211-68.049c37.563,0,68.132,30.518,68.211,68.063
		c-0.005,0.116-0.009,0.238-0.009,0.329c0,3.196,2.505,5.831,5.696,5.992c34.37,1.741,61.292,30.038,61.292,64.421
		c0,19.526-8.698,37.801-23.864,50.138c-2.571,2.091-2.959,5.87-0.868,8.44c2.091,2.571,5.87,2.959,8.44,0.868
		c17.98-14.626,28.292-36.293,28.292-59.447C294.156,145.269,265.08,112.926,227.002,108.256z"
      />
      <path d="M140.966,141.078v76.511c0,3.313,2.687,6,6,6s6-2.687,6-6v-76.511c0-3.313-2.687-6-6-6S140.966,137.765,140.966,141.078z" />
      <path
        d="M181.283,152.204c1.536,0,3.071-0.586,4.243-1.757c2.343-2.343,2.343-6.142,0-8.485l-34.317-34.317
		c-2.343-2.343-6.143-2.343-8.485,0l-34.317,34.317c-2.343,2.343-2.343,6.142,0,8.485c2.343,2.343,6.143,2.343,8.485,0
		l30.074-30.074l30.074,30.074C178.212,151.618,179.748,152.204,181.283,152.204z"
      />
    </g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
  </svg>
);

export const StarIcon = () => (
  <svg
    version="1.1"
    id="Capa_1"
    x="0px"
    y="0px"
    viewBox="0 0 294.843 294.843"
  >
    <g>
      <path
        d="M199.628,175.487c-0.632-1.977,0.067-4.131,1.741-5.358l37.422-27.455c5.958-4.371,8.333-11.736,6.049-18.763
                c-2.283-7.028-8.533-11.591-15.922-11.625l-46.413-0.215c-2.076-0.01-3.908-1.34-4.558-3.311l-14.547-44.076
                c-2.316-7.017-8.586-11.55-15.975-11.551h0c-7.389,0-13.66,4.534-15.976,11.55l-6.557,19.859c-1.039,3.146,0.669,6.54,3.816,7.578
                c3.147,1.041,6.539-0.669,7.579-3.816l6.557-19.859c1.014-3.073,3.762-3.312,4.581-3.312c0.818,0,3.566,0.239,4.58,3.312
                l14.547,44.077c2.27,6.875,8.658,11.516,15.897,11.55l46.413,0.215c3.236,0.015,4.313,2.555,4.565,3.333
                c0.253,0.778,0.875,3.465-1.734,5.379l-37.423,27.455c-5.837,4.283-8.277,11.793-6.072,18.689l14.143,44.222
                c0.986,3.083-1.097,4.892-1.759,5.372c-0.662,0.481-3.025,1.904-5.652,0.013l-37.677-27.114c-5.878-4.229-13.776-4.229-19.654,0
                l-37.684,27.119c-2.627,1.89-4.991,0.468-5.652-0.012c-0.662-0.481-2.745-2.289-1.76-5.371l14.139-44.229
                c2.205-6.895-0.236-14.405-6.072-18.688l-37.421-27.455c-2.609-1.914-1.987-4.602-1.734-5.379c0.253-0.778,1.33-3.318,4.565-3.333
                l46.416-0.215c3.313-0.016,5.987-2.714,5.972-6.028c-0.016-3.304-2.699-5.972-6-5.972c-0.009,0-0.019,0-0.028,0l-46.416,0.215
                c-7.389,0.034-13.639,4.597-15.922,11.625c-2.283,7.028,0.091,14.393,6.048,18.764l37.421,27.455
                c1.673,1.228,2.373,3.381,1.741,5.358l-14.138,44.229c-2.25,7.038,0.159,14.392,6.137,18.734c3,2.179,6.442,3.269,9.886,3.269
                c3.419,0,6.84-1.075,9.829-3.225l37.683-27.119c1.685-1.213,3.95-1.213,5.635,0l37.677,27.114c5.998,4.316,13.736,4.3,19.715-0.044
                c5.979-4.343,8.387-11.697,6.136-18.736L199.628,175.487z"
      />
      <path
        d="M147.421,0C66.133,0,0,66.133,0,147.421s66.133,147.421,147.421,147.421c3.313,0,6-2.687,6-6s-2.687-6-6-6
                C72.75,282.843,12,222.093,12,147.421S72.75,12,147.421,12s135.421,60.75,135.421,135.421c0,46.48-23.42,89.182-62.65,114.228
                c-2.793,1.783-3.612,5.493-1.829,8.286c1.783,2.793,5.492,3.612,8.286,1.829c42.7-27.262,68.193-73.745,68.193-124.342
                C294.843,66.133,228.71,0,147.421,0z"
      />
    </g>
  </svg>
);

export const FolderIcon = () => (
  <svg
    version="1.1"
    id="Capa_1"
    x="0px"
    y="0px"
    viewBox="0 0 294.843 294.843"
  >
    <g>
      <path
        d="M6,40.77c3.313,0,6-2.686,6-6c0-9.256,7.53-16.786,16.786-16.786h53.675l42.243,46.147
            c1.137,1.242,2.743,1.949,4.426,1.949h136.928c9.256,0,16.786,7.53,16.786,16.786c0,3.314,2.687,6,6,6s6-2.686,6-6
            c0-15.873-12.913-28.786-28.786-28.786H131.771L89.529,7.933c-1.137-1.242-2.743-1.949-4.426-1.949H28.786
            C12.913,5.984,0,18.897,0,34.77C0,38.083,2.687,40.77,6,40.77z"
      />
      <path
        d="M266.057,94.104H131.771L89.529,47.957c-1.137-1.242-2.743-1.949-4.426-1.949H28.786C12.913,46.008,0,58.921,0,74.793
            v118.628c0,3.313,2.687,6,6,6s6-2.687,6-6V74.793c0-9.256,7.53-16.786,16.786-16.786h53.675l42.243,46.147
            c1.137,1.242,2.743,1.949,4.426,1.949h136.928c9.256,0,16.786,7.53,16.786,16.786v137.184c0,9.255-7.53,16.786-16.786,16.786
            H28.786c-9.256,0-16.786-7.53-16.786-16.786c0-3.313-2.687-6-6-6s-6,2.687-6,6c0,15.873,12.913,28.786,28.786,28.786h237.271
            c15.873,0,28.786-12.913,28.786-28.786V122.89C294.843,107.017,281.93,94.104,266.057,94.104z"
      />
    </g>
  </svg>
);

export const UploadIconOpenItem = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="10"
      cy="10"
      r="9.5"
      fill="#2F80ED"
      stroke="#2F80ED"
    />
    <path
      d="M14 11V13C14 13.2652 13.9063 13.5196 13.7397 13.7071C13.573 13.8946 13.3469 14 13.1111 14H6.88889C6.65314 14 6.42705 13.8946 6.26035 13.7071C6.09365 13.5196 6 13.2652 6 13V11"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.7288 8.12496L10.1615 5.54688L7.59424 8.12496"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.1616 5.54688V11.7343"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const ProgressIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 0 24 24"
    width="24px"
    fill="#000000"
  >
    <path
      d="M0 0h24v24H0V0z"
      fill="none"
    />
    <path d="M16.85 6.85l1.44 1.44-4.88 4.88-3.29-3.29c-.39-.39-1.02-.39-1.41 0l-6 6.01c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L9.41 12l3.29 3.29c.39.39 1.02.39 1.41 0l5.59-5.58 1.44 1.44c.31.31.85.09.85-.35V6.5c.01-.28-.21-.5-.49-.5h-4.29c-.45 0-.67.54-.36.85z" />
  </svg>
);

export const IconDelete = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="24"
    viewBox="0 0 20 24"
    fill="none"
  >
    <path
      d="M8 0c-.523 0-1.059.184-1.438.563C6.184.94 6 1.477 6 2v1H0v2h1v16c0 1.645 1.355 3 3 3h12c1.645 0 3-1.355 3-3V5h1V3h-6V2c0-.523-.184-1.059-.563-1.438C13.06.184 12.524 0 12 0H8zm0 2h4v1H8V2zM3 5h14v16c0 .555-.445 1-1 1H4c-.555 0-1-.445-1-1V5zm2 3v11h2V8H5zm4 0v11h2V8H9zm4 0v11h2V8h-2z"
      fill="#D43"
    />
  </svg>
);

export const IconPlusCircle = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
  >
    <path
      d="M9.5 0C4.262 0 0 4.262 0 9.5S4.262 19 9.5 19 19 14.738 19 9.5 14.738 0 9.5 0zm0 1.462A8.028 8.028 0 0 1 17.538 9.5 8.028 8.028 0 0 1 9.5 17.538 8.028 8.028 0 0 1 1.462 9.5 8.028 8.028 0 0 1 9.5 1.462zm-.73 3.653V8.77H5.114v1.462H8.77v3.654h1.462V10.23h3.654V8.769H10.23V5.115H8.769z"
      fill="#D43"
    />
  </svg>
);

export const IconEdit = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      d="M20.188 0a4.097 4.097 0 0 0-2.907 1.219L1.47 17.03l-.063.313-1.093 5.5L0 24.312 1.469 24l5.5-1.094.312-.062L23.094 7.03a4.075 4.075 0 0 0 0-5.812A4.097 4.097 0 0 0 20.187 0zm0 1.906c.503 0 1.011.23 1.5.719.972.973.972 2.027 0 3l-.72.688L18 3.342l.688-.718c.488-.488.996-.719 1.5-.719zM16.593 4.75l2.968 2.969L7.47 19.812A6.813 6.813 0 0 0 4.5 16.845L16.594 4.75zM3.219 18.469a4.733 4.733 0 0 1 2.625 2.625l-3.282.656.657-3.281z"
      fill="#D43"
    />
  </svg>
);

export const IconDownArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="26"
    viewBox="0 0 28 26"
    fill="none"
  >
    <path
      d="M14.264 0C6.907 0 .922 5.832.922 13s5.985 13 13.342 13c7.356 0 13.341-5.832 13.341-13S21.62 0 14.264 0zm0 2c6.246 0 11.289 4.914 11.289 11s-5.043 11-11.29 11C8.019 24 2.975 19.086 2.975 13S8.018 2 14.264 2zm-1.027 4v10h-3.079l4.106 4 4.105-4H15.29V6h-2.053z"
      fill="#D43"
    />
  </svg>
);

export const IconUpArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="26"
    viewBox="0 0 28 26"
    fill="none"
  >
    <path
      d="M14.212 26c7.37 0 13.366-5.832 13.366-13S21.582 0 14.212 0C6.842 0 .846 5.832.846 13s5.996 13 13.366 13zm0-2c-6.257 0-11.31-4.914-11.31-11S7.955 2 14.212 2c6.257 0 11.31 4.914 11.31 11s-5.053 11-11.31 11zm1.028-4V10h3.085l-4.113-4-4.113 4h3.085v10h2.056z"
      fill="#D43"
    />
  </svg>
);

export const DebitArrow = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 6c0 .56.45 1 1 1h5.59L4.7 17.89a.996.996 0 1 0 1.41 1.41L17 8.41V14c0 .55.45 1 1 1s1-.45 1-1V6c0-.55-.45-1-1-1h-8c-.55 0-1 .45-1 1z"
      fill="#FD8458"
    />
  </svg>
);

export const CreditArrow = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 18c0-.56-.45-1-1-1H8.41L19.3 6.11a.996.996 0 1 0-1.41-1.41L7 15.59V10c0-.55-.45-1-1-1s-1 .45-1 1v8c0 .55.45 1 1 1h8c.55 0 1-.45 1-1z"
      fill="#4CD0A0"
    />
  </svg>
);

export const RupeeIcon = () => (
  <svg
    width="12"
    height="15"
    viewBox="0 0 12 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.854 3.74v.323h2.451v1.254H8.759c-.114.874-.367 1.558-.76 2.052-.38.494-.937.849-1.672 1.064-.722.215-1.685.323-2.888.323v1.501c0 1.71.747 2.565 2.242 2.565 1.47 0 2.204-.823 2.204-2.47h1.596c-.013 1.267-.348 2.223-1.007 2.869-.659.646-1.596.969-2.812.969-1.254 0-2.21-.348-2.869-1.045-.646-.697-.969-1.672-.969-2.926V7.54c1.444 0 2.508-.044 3.192-.133.697-.101 1.203-.304 1.52-.608.317-.317.52-.81.608-1.482H.969V4.063H7.22V2.011H.969V.738h10.336v1.273H8.854V3.74z"
      fill="#797F84"
    />
  </svg>
);

export const PlusIconCircle = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 39 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.5 0C8.748 0 0 8.748 0 19.5S8.748 39 19.5 39 39 30.252 39 19.5 30.252 0 19.5 0zm0 3C28.629 3 36 10.371 36 19.5S28.629 36 19.5 36 3 28.629 3 19.5 10.371 3 19.5 3zM18 10.5V18h-7.5v3H18v7.5h3V21h7.5v-3H21v-7.5h-3z"
      fill="#D43"
    />
  </svg>
);

export const UploadNew = () => (
  <svg
    width="22"
    height="16"
    viewBox="0 0 22 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 0C8.92 0 7.111.99 5.82 2.45c-.108-.013-.203-.05-.32-.05-1.728 0-3.143 1.44-3.143 3.2C.997 6.444 0 7.869 0 9.6c0 2.64 2.12 4.8 4.714 4.8h3.929v-1.6H4.714c-1.743 0-3.143-1.425-3.143-3.2 0-1.328.792-2.462 1.916-2.95l.54-.225-.074-.6c-.015-.131-.024-.206-.024-.225 0-.894.693-1.6 1.571-1.6.11 0 .233.016.368.05l.491.125.295-.4C7.661 2.459 9.232 1.6 11 1.6c2.575 0 4.723 1.803 5.328 4.225l.147.625.663-.025c.166-.01.203-.025.148-.025 1.743 0 3.143 1.425 3.143 3.2 0 1.775-1.4 3.2-3.143 3.2h-3.929v1.6h3.929C19.879 14.4 22 12.24 22 9.6a4.735 4.735 0 0 0-4.395-4.725C16.645 2.059 14.085 0 11 0zm0 6.4L7.857 9.6h2.357V16h1.572V9.6h2.357L11 6.4z"
      fill="#D43"
    />
  </svg>
);

export const Excel = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
  >
    <path
      d="m3.217 3.237 14.14-2.02a.562.562 0 0 1 .643.557v23.452a.562.562 0 0 1-.641.557l-14.144-2.02a1.125 1.125 0 0 1-.966-1.113V4.35a1.125 1.125 0 0 1 .966-1.113h.002zm15.908.138h4.5A1.125 1.125 0 0 1 24.75 4.5v18a1.125 1.125 0 0 1-1.125 1.125h-4.5V3.375zM11.475 13.5l3.15-4.5h-2.7l-1.8 2.572L8.325 9h-2.7l3.15 4.5-3.15 4.5h2.7l1.8-2.571 1.8 2.571h2.7l-3.15-4.5z"
      fill="#D43"
    />
  </svg>
);

export const Error = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="202"
    height="202"
    viewBox="0 0 202 202"
    fill="none"
  >
    <g
      clip-path="url(#b0av37sosa)"
      fill="#D43"
    >
      <path d="M181.662 45.91h-14.217v5.924h12.835v13.032H21.918V51.834h113.934V45.91H20.536a4.547 4.547 0 0 0-4.542 4.542V81.15c-3.668 1.24-6.318 4.712-6.318 8.793 0 4.082 2.65 7.554 6.319 8.794v62.291a4.547 4.547 0 0 0 4.541 4.542h23.695v-5.924H21.918v-60.91c3.669-1.239 6.319-4.71 6.319-8.793 0-4.081-2.65-7.554-6.319-8.793V70.79H180.28v88.856h-22.313v5.924h23.695a4.547 4.547 0 0 0 4.542-4.542V50.452a4.547 4.547 0 0 0-4.542-4.542zM18.956 93.3a3.36 3.36 0 0 1-3.356-3.357 3.36 3.36 0 0 1 3.356-3.356 3.36 3.36 0 0 1 3.357 3.356 3.36 3.36 0 0 1-3.357 3.357z" />
      <path d="M31.594 55.387h6.318v5.923h-6.318v-5.923zM44.23 55.387h6.32v5.923h-6.32v-5.923zM56.867 55.387h6.319v5.923h-6.319v-5.923zM148.688 58.349h5.924v-6.516h6.516v-5.924h-6.516v-6.516h-5.924v6.516h-6.516v5.924h6.516v6.516zM12.44 42.552v-6.516h6.516v-5.924H12.44v-6.516H6.516v6.516H0v5.924h6.516v6.516h5.924zM192.718 20.635c-5.117 0-9.28 4.163-9.28 9.28 0 5.118 4.163 9.28 9.28 9.28 5.117 0 9.281-4.162 9.281-9.28 0-5.117-4.164-9.28-9.281-9.28zm0 12.637a3.36 3.36 0 0 1-3.357-3.357 3.36 3.36 0 0 1 3.357-3.357 3.36 3.36 0 0 1 3.357 3.357 3.36 3.36 0 0 1-3.357 3.357zM108.902 94.956a9.23 9.23 0 0 0 1.477-5.013c0-5.118-4.164-9.28-9.281-9.28-5.117 0-9.28 4.162-9.28 9.28 0 1.846.543 3.566 1.476 5.013L74.4 118.574H50.746v62.792H151.45v-62.792h-23.654l-18.894-23.618zm-7.804-8.37a3.36 3.36 0 0 1 3.357 3.357 3.36 3.36 0 0 1-3.357 3.356 3.36 3.36 0 0 1-3.357-3.356 3.36 3.36 0 0 1 3.357-3.357zM97.916 98.66a9.24 9.24 0 0 0 3.182.562 9.242 9.242 0 0 0 3.182-.562l15.93 19.913H81.986l15.93-19.913zm47.61 76.781H56.67v-50.944h88.856v50.944z" />
      <path d="M79.18 168.926h5.924v-37.912H79.18v15.994h-6.713v-15.994h-5.924v21.918H79.18v15.994zM129.731 168.926h5.924v-37.912h-5.924v15.994h-6.713v-15.994h-5.924v21.918h12.637v15.994zM110.378 131.211H91.816v37.517h18.562v-37.517zm-5.924 31.593H97.74v-25.669h6.714v25.669z" />
    </g>
    <defs>
      <clipPath id="b0av37sosa">
        <path
          fill="#fff"
          d="M0 0h202v202H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

export const BulkUploadSuccess = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="55"
    height="55"
    viewBox="0 0 55 55"
    fill="none"
  >
    <circle
      cx="27.5"
      cy="27.5"
      r="27.5"
      fill="#EBF5D5"
    />
    <path
      d="m18.53 38.677-4.87-.99a1.225 1.225 0 0 1-.83-.514 1.24 1.24 0 0 1-.238-.95l.554-4.71-3.127-3.603a1.416 1.416 0 0 1-.317-.91c0-.343.106-.647.317-.91l3.127-3.563-.554-4.71c-.053-.37.026-.693.237-.97s.488-.455.831-.535l4.87-.95 2.453-4.235c.159-.29.41-.495.752-.614a1.23 1.23 0 0 1 .99.06L27 12.552l4.275-1.98c.317-.157.647-.19.99-.098.343.092.593.297.752.613l2.493 4.275 4.83.95c.343.08.62.258.83.535.212.277.291.6.238.97l-.554 4.71 3.127 3.563c.211.263.317.567.317.91 0 .343-.106.646-.317.91l-3.127 3.602.554 4.71a1.24 1.24 0 0 1-.237.95c-.211.291-.488.463-.831.515l-4.83.99-2.493 4.235a1.135 1.135 0 0 1-.753.614c-.343.092-.672.06-.99-.099L27 41.447l-4.275 1.98a1.23 1.23 0 0 1-.99.06 1.304 1.304 0 0 1-.752-.614l-2.454-4.196zm5.818-7.283c.264.264.58.396.95.396s.686-.132.95-.396l7.244-7.165c.21-.237.31-.521.297-.85a1.384 1.384 0 0 0-.377-.892 1.22 1.22 0 0 0-.89-.336c-.33.013-.64.139-.93.376l-6.294 6.254-2.85-3.008a1.113 1.113 0 0 0-.91-.376c-.37.013-.687.152-.95.415-.238.29-.363.607-.377.95-.013.343.113.647.376.91l3.76 3.722zm-1.544 8.985L27 38.598l4.314 1.781 2.653-3.919 4.591-1.187-.475-4.671L41.25 27l-3.167-3.681.475-4.671-4.591-1.108-2.732-3.92L27 15.363l-4.315-1.741-2.652 3.918-4.552 1.109.436 4.67L12.75 27l3.167 3.602-.436 4.75 4.552 1.108 2.771 3.92z"
      fill="#82B01F"
    />
  </svg>
);

export const BulkUploadError = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="55"
    height="55"
    viewBox="0 0 55 55"
    fill="none"
  >
    <circle
      cx="27.5"
      cy="27.5"
      r="27.5"
      fill="#FFE5DA"
    />
    <path
      d="M27 43.07c-2.217 0-4.301-.421-6.254-1.266-1.953-.844-3.655-1.992-5.106-3.444-1.452-1.45-2.6-3.153-3.444-5.106-.845-1.953-1.267-4.037-1.267-6.254 0-2.217.422-4.308 1.267-6.274.844-1.966 1.992-3.668 3.444-5.106 1.45-1.438 3.153-2.58 5.106-3.424 1.953-.845 4.037-1.267 6.254-1.267 2.217 0 4.301.422 6.254 1.267 1.953.844 3.655 1.986 5.106 3.424 1.452 1.438 2.6 3.14 3.444 5.106.845 1.966 1.267 4.057 1.267 6.274 0 2.217-.422 4.301-1.267 6.254-.844 1.953-1.992 3.655-3.444 5.106-1.451 1.452-3.153 2.6-5.106 3.444-1.953.845-4.037 1.267-6.254 1.267zm0-2.69c3.72 0 6.88-1.3 9.48-3.9 2.6-2.6 3.9-5.76 3.9-9.48 0-1.557-.265-3.061-.793-4.512a13.394 13.394 0 0 0-2.256-3.959L18.53 37.292a11.759 11.759 0 0 0 3.939 2.315c1.464.515 2.975.772 4.532.772zm-10.292-4.91 18.763-18.762a12.949 12.949 0 0 0-3.958-2.295A13.106 13.106 0 0 0 27 13.62c-3.72 0-6.88 1.293-9.48 3.879-2.6 2.586-3.9 5.753-3.9 9.5 0 1.557.278 3.061.832 4.512a14.668 14.668 0 0 0 2.256 3.959z"
      fill="#E7733E"
    />
  </svg>
);

export const TeamMemberIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 13.525 6.525 11 4 8.475 1.475 11 4 13.525zM17.5 13 20 9l2.5 4h-5zM12 12a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 9 9c0-.85.292-1.563.875-2.138S11.167 6 12 6c.85 0 1.563.287 2.137.862C14.712 7.438 15 8.15 15 9c0 .833-.287 1.542-.863 2.125-.575.583-1.287.875-2.137.875zm0-4a.968.968 0 0 0-.713.287A.967.967 0 0 0 11 9c0 .283.096.52.287.713.192.191.43.287.713.287s.52-.096.713-.287A.967.967 0 0 0 13 9a.967.967 0 0 0-.287-.713A.968.968 0 0 0 12 8zM0 18v-1.575c0-.733.37-1.32 1.113-1.763C1.853 14.221 2.817 14 4 14c.217 0 .425.004.625.012.2.009.392.03.575.063a3.787 3.787 0 0 0-.525 1.075 4.186 4.186 0 0 0-.175 1.225V18H0zm6 0v-1.625c0-1.083.554-1.958 1.662-2.625 1.109-.667 2.555-1 4.338-1 1.8 0 3.25.333 4.35 1 1.1.667 1.65 1.542 1.65 2.625V18H6zm14-4c1.2 0 2.167.22 2.9.662.733.442 1.1 1.03 1.1 1.763V18h-4.5v-1.625c0-.433-.054-.842-.163-1.225a3.913 3.913 0 0 0-.487-1.075c.183-.033.37-.054.563-.063.191-.008.387-.012.587-.012zm-8 .75c-.95 0-1.8.125-2.55.375-.75.25-1.192.542-1.325.875H15.9c-.15-.333-.596-.625-1.338-.875-.741-.25-1.595-.375-2.562-.375z"
      fill="#D43"
    />

    {/* <defs>
    <clipPath id="1km9mi58ra">
        <path fill="#fff" d="M0 0h24v24H0z"/>
    </clipPath>
</defs> */}
  </svg>
);

export const RreshIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 20c-2.233 0-4.125-.775-5.675-2.325C4.775 16.125 4 14.233 4 12c0-2.233.775-4.125 2.325-5.675C7.875 4.775 9.767 4 12 4c1.15 0 2.25.237 3.3.713A7.623 7.623 0 0 1 18 6.75V4h2v7h-7V9h4.2a5.836 5.836 0 0 0-2.188-2.2A5.928 5.928 0 0 0 12 6c-1.667 0-3.083.583-4.25 1.75C6.583 8.917 6 10.333 6 12c0 1.667.583 3.083 1.75 4.25C8.917 17.417 10.333 18 12 18a5.863 5.863 0 0 0 3.475-1.1A5.81 5.81 0 0 0 17.65 14h2.1c-.467 1.767-1.417 3.208-2.85 4.325S13.833 20 12 20z"
      fill="#D43"
    />
  </svg>
);

export const UploadIconMultiColor = ({ color = "currentColor" }) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.001 14.827a.668.668 0 0 1-.687-.687V6.325L8.045 8.594a.62.62 0 0 1-.481.195.703.703 0 0 1-.481-.218.672.672 0 0 1-.207-.493c0-.19.069-.355.207-.493l3.437-3.437a.697.697 0 0 1 .23-.16.673.673 0 0 1 .251-.046c.092 0 .176.015.252.046.077.03.153.084.23.16l3.46 3.46a.66.66 0 0 1 .206.482.66.66 0 0 1-.206.48.673.673 0 0 1-.493.207.672.672 0 0 1-.492-.206l-2.27-2.246v7.815a.668.668 0 0 1-.687.687zm-5.958 3.506a1.32 1.32 0 0 1-.963-.412 1.32 1.32 0 0 1-.412-.963v-2.59a.668.668 0 0 1 .687-.687.668.668 0 0 1 .688.688v2.59H16.96v-2.59a.668.668 0 0 1 .687-.688.668.668 0 0 1 .688.688v2.59c0 .366-.138.687-.413.962a1.32 1.32 0 0 1-.962.412H5.043z"
      fill={color}
    />
  </svg>
);

export const CallLogIcon = ({ color = "currentColor" }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.50121 1.5V0H16.0012V1.5H8.50121ZM8.50121 4.5V3H16.0012V4.5H8.50121ZM8.50121 7.5V6H16.0012V7.5H8.50121ZM12.8554 15.9583C11.1748 15.8333 9.58454 15.4201 8.08454 14.7188C6.58454 14.0174 5.23732 13.0694 4.04288 11.875C2.84843 10.6806 1.91093 9.33681 1.23038 7.84375C0.54982 6.35069 0.140098 4.76389 0.00120936 3.08333C-0.0265684 2.79167 0.0587788 2.53819 0.257251 2.32292C0.455584 2.10764 0.70357 2 1.00121 2H3.83454C4.07065 2 4.27552 2.07292 4.44913 2.21875C4.62274 2.36458 4.73732 2.54861 4.79288 2.77083L5.29288 4.97917C5.32065 5.15972 5.31024 5.33333 5.26163 5.5C5.21302 5.66667 5.13315 5.80556 5.02204 5.91667L3.00121 7.95833C3.27899 8.48611 3.59843 8.98958 3.95954 9.46875C4.32065 9.94792 4.71961 10.4026 5.15642 10.8329C5.56683 11.2499 6.00468 11.6354 6.46996 11.9896C6.93524 12.3438 7.43177 12.6597 7.95954 12.9375L10.022 10.9375C10.1273 10.8264 10.2648 10.7431 10.4343 10.6875C10.6039 10.6319 10.779 10.625 10.9595 10.6667L13.1887 11.1458C13.4248 11.2014 13.6123 11.3194 13.7512 11.5C13.8901 11.6806 13.9595 11.8889 13.9595 12.125V14.9583C13.9595 15.256 13.8484 15.504 13.6262 15.7023C13.404 15.9008 13.147 15.9861 12.8554 15.9583ZM2.31371 6.5L3.77204 5.04167L3.41454 3.5H1.54288C1.61232 4.02778 1.70954 4.53819 1.83454 5.03125C1.95954 5.52431 2.11927 6.01389 2.31371 6.5ZM9.43871 13.6458C9.92621 13.8436 10.4231 14.0007 10.9293 14.1171C11.4356 14.2335 11.9457 14.3264 12.4595 14.3958V12.5208L10.897 12.1875L9.43871 13.6458Z"
      fill={color}
    />
  </svg>
);

export const HourglassIcon = ({ color = "#E7733E" }: { color?: string }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 11C13.1 11 14.0417 10.6083 14.825 9.825C15.6083 9.04167 16 8.1 16 7V4H8V7C8 8.1 8.39167 9.04167 9.175 9.825C9.95833 10.6083 10.9 11 12 11ZM4 22V20H6V17C6 15.9833 6.2375 15.0292 6.7125 14.1375C7.1875 13.2458 7.85 12.5333 8.7 12C7.85 11.4667 7.1875 10.7542 6.7125 9.8625C6.2375 8.97083 6 8.01667 6 7V4H4V2H20V4H18V7C18 8.01667 17.7625 8.97083 17.2875 9.8625C16.8125 10.7542 16.15 11.4667 15.3 12C16.15 12.5333 16.8125 13.2458 17.2875 14.1375C17.7625 15.0292 18 15.9833 18 17V20H20V22H4Z"
      fill={color}
    />
  </svg>
);

export const SyncIcon = ({ size = 20, color = "#D43" }) => {
  const maskId = "sync-mask-" + Math.random().toString(36).substr(2, 9);

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id={maskId}
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect
          width="20"
          height="20"
          fill="#D9D9D9"
        />
      </mask>

      <g mask={`url(#${maskId})`}>
        <path
          d="M4.72917 12.7917C4.50694 12.375 4.32986 11.934 4.19792 11.4688C4.06597 11.0035 4 10.5139 4 10C4 8.31944 4.59028 6.88889 5.77083 5.70833C6.95139 4.52778 8.40278 3.95833 10.125 4L8.9375 2.8125L10 1.75L13 4.75L10 7.75L8.9375 6.6875L10.125 5.5C8.81944 5.47222 7.72222 5.90278 6.83333 6.79167C5.94444 7.68056 5.5 8.75 5.5 10C5.5 10.3056 5.52778 10.5972 5.58333 10.875C5.63889 11.1528 5.72222 11.4236 5.83333 11.6875L4.72917 12.7917ZM10 18.25L7 15.25L10 12.25L11.0625 13.3125L9.875 14.5C11.1806 14.5278 12.2778 14.0972 13.1667 13.2083C14.0556 12.3194 14.5 11.25 14.5 10C14.5 9.69444 14.4722 9.40278 14.4167 9.125C14.3611 8.84722 14.2778 8.57639 14.1667 8.3125L15.2708 7.20833C15.4931 7.625 15.6701 8.06597 15.8021 8.53125C15.934 8.99653 16 9.48611 16 10C16 11.6667 15.4097 13.0938 14.2292 14.2812C13.0486 15.4688 11.5972 16.0417 9.875 16L11.0625 17.1875L10 18.25Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export const UnlockIcon = ({ size = 24, color = "#085041" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}px`}
    width={`${size}px`}
    viewBox="0 -960 960 960"
    fill={color}
  >
    <path
      d="M240-640h360v-80q0-50-35-85t-85-35
q-50 0-85 35t-35 85h-80q0-83 58.5-141.5
T480-920q83 0 141.5 58.5T680-720v80h40
q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5
T720-80H240q-33 0-56.5-23.5T160-160v-400
q0-33 23.5-56.5T240-640Zm0 480h480v-400H240v400Z
m240-120q33 0 56.5-23.5T560-360q0-33-23.5-56.5
T480-440q-33 0-56.5 23.5T400-360q0 33 23.5 56.5
T480-280ZM240-160v-400 400Z"
    />
  </svg>
);

export const DownloadArrowIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 2v8.5M4.5 7.5L8 11l3.5-3.5M3 14h10"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DocumentIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path
      d="M14 2v5h5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path
      d="M8 13h8M8 17h8M8 9h3"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

export const ChartLineIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 3v16a2 2 0 0 0 2 2h16"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 14l4-4 3 3 6-7"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EnvelopeIcon = ({ size = 22 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="3"
      y="5"
      width="18"
      height="14"
      rx="2"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    <path
      d="M3 7l9 6 9-6"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const InfoIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="8"
      cy="8"
      r="7"
      stroke="currentColor"
      strokeWidth="1.3"
    />
    <path
      d="M8 7.2v4"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
    <circle
      cx="8"
      cy="5.1"
      r="0.9"
      fill="currentColor"
    />
  </svg>
);

export const ListIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_379_10810"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <rect
        width="20"
        height="20"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_379_10810)">
      <path
        d="M8.38178 15.625C8.2047 15.625 8.05623 15.5651 7.93637 15.4452C7.81665 15.3254 7.75678 15.1769 7.75678 14.9998C7.75678 14.8226 7.81665 14.6742 7.93637 14.5546C8.05623 14.4349 8.2047 14.375 8.38178 14.375H16.4587C16.6357 14.375 16.7841 14.4349 16.9039 14.5548C17.0237 14.6747 17.0837 14.8231 17.0837 15.0002C17.0837 15.1775 17.0237 15.3259 16.9039 15.4454C16.7841 15.5652 16.6357 15.625 16.4587 15.625H8.38178ZM8.38178 10.625C8.2047 10.625 8.05623 10.5651 7.93637 10.4452C7.81665 10.3254 7.75678 10.1769 7.75678 9.99981C7.75678 9.82259 7.81665 9.67419 7.93637 9.5546C8.05623 9.43488 8.2047 9.37502 8.38178 9.37502H16.4587C16.6357 9.37502 16.7841 9.43495 16.9039 9.55481C17.0237 9.67467 17.0837 9.82314 17.0837 10.0002C17.0837 10.1775 17.0237 10.3259 16.9039 10.4454C16.7841 10.5652 16.6357 10.625 16.4587 10.625H8.38178ZM8.38178 5.62502C8.2047 5.62502 8.05623 5.56509 7.93637 5.44523C7.81665 5.32537 7.75678 5.17689 7.75678 4.99981C7.75678 4.82259 7.81665 4.67419 7.93637 4.5546C8.05623 4.43488 8.2047 4.37502 8.38178 4.37502H16.4587C16.6357 4.37502 16.7841 4.43495 16.9039 4.55481C17.0237 4.67467 17.0837 4.82314 17.0837 5.00023C17.0837 5.17745 17.0237 5.32585 16.9039 5.44544C16.7841 5.56516 16.6357 5.62502 16.4587 5.62502H8.38178ZM4.30324 16.3863C3.92199 16.3863 3.59567 16.2505 3.32428 15.979C3.05276 15.7076 2.91699 15.3813 2.91699 15C2.91699 14.6188 3.05276 14.2924 3.32428 14.0211C3.59567 13.7495 3.92199 13.6138 4.30324 13.6138C4.68449 13.6138 5.01081 13.7495 5.2822 14.0211C5.55373 14.2924 5.68949 14.6188 5.68949 15C5.68949 15.3813 5.55373 15.7076 5.2822 15.979C5.01081 16.2505 4.68449 16.3863 4.30324 16.3863ZM4.30324 11.3863C3.92199 11.3863 3.59567 11.2511 3.32428 10.9809C3.05276 10.7104 2.91699 10.3835 2.91699 10C2.91699 9.61655 3.05276 9.2896 3.32428 9.01919C3.59567 8.74891 3.92199 8.61377 4.30324 8.61377C4.68449 8.61377 5.01081 8.74891 5.2822 9.01919C5.55373 9.2896 5.68949 9.61655 5.68949 10C5.68949 10.3835 5.55373 10.7104 5.2822 10.9809C5.01081 11.2511 4.68449 11.3863 4.30324 11.3863ZM3.32241 5.98085C3.05213 5.71044 2.91699 5.38349 2.91699 5.00002C2.91699 4.61655 3.05213 4.2896 3.32241 4.01919C3.59269 3.74891 3.91963 3.61377 4.30324 3.61377C4.68671 3.61377 5.01366 3.74891 5.28408 4.01919C5.55435 4.2896 5.68949 4.61655 5.68949 5.00002C5.68949 5.38349 5.55435 5.71044 5.28408 5.98085C5.01366 6.25113 4.68671 6.38627 4.30324 6.38627C3.91963 6.38627 3.59269 6.25113 3.32241 5.98085Z"
        fill="#DD4433"
      />
    </g>
  </svg>
);

export const QuickViewIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_240_7650"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <rect
        width="20"
        height="20"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_240_7650)">
      <path
        d="M3.58971 16.25C3.17415 16.25 2.81915 16.1028 2.52471 15.8085C2.2304 15.5141 2.08325 15.1591 2.08325 14.7435V5.25646C2.08325 4.8409 2.2304 4.4859 2.52471 4.19146C2.81915 3.89715 3.17415 3.75 3.58971 3.75H16.4101C16.8257 3.75 17.1807 3.89715 17.4751 4.19146C17.7694 4.4859 17.9166 4.8409 17.9166 5.25646V14.7435C17.9166 15.1591 17.7694 15.5141 17.4751 15.8085C17.1807 16.1028 16.8257 16.25 16.4101 16.25H3.58971ZM7.91658 15H16.4101C16.485 15 16.5464 14.976 16.5945 14.9279C16.6426 14.8799 16.6666 14.8184 16.6666 14.7435V5.25646C16.6666 5.1816 16.6426 5.12014 16.5945 5.07208C16.5464 5.02403 16.485 5 16.4101 5H7.91658V15ZM6.66658 15V5H3.58971C3.51485 5 3.45339 5.02403 3.40534 5.07208C3.35728 5.12014 3.33325 5.1816 3.33325 5.25646V14.7435C3.33325 14.8184 3.35728 14.8799 3.40534 14.9279C3.45339 14.976 3.51485 15 3.58971 15H6.66658Z"
        fill="#DD4433"
      />
    </g>
  </svg>
);
